<template>
    <component
        :is="tag"
        class="sbs-tabs custom-scrollbar"
        :class="themeClasses">
        <!-- @slot Слот по-умолчанию для компонентов SbsTab -->
        <slot></slot>

        <SbsTabUnderline
            v-if="underlined && stickyUnderline"
            v-bind="tabUnderlineData" />
    </component>
</template>

<script>
import themesMixin from '../../mixins/themes.js';
import { AllColors } from '../../utils/colors.js';

export default {
    name: 'SbsTabs',
    mixins: [themesMixin],
    emits: ['update:modelValue', 'change'],
    provide() {
        return {
            tabsComponent: this,
        };
    },
    data() {
        return {
            activeDomElement: null,
        };
    },
    computed: {
        tabUnderlineData() {
            return {
                hoverUnderline: this.hoverUnderline,
                tabDomElement: this.activeDomElement,
                underlineTheme: this.underlineTheme,
            };
        },
    },
    methods: {
        tabChangeHandler({ element, value }) {
            /**
             * Событие `change` срабатывает при изменении активного таба.
             * В качестве параметра - значение индекса активного таба
             */
            this.$emit('update:modelValue', value);
            this.$emit('change', value);
            this.activeDomElement = element;
        },
    },
    props: {
        /**
         * Отключает взаимодействие с компонентом
         */
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Тема (цветовые решения) для цвета нижнего подчеркивания при наведении
         */
        hoverUnderline: {
            type: String,
            default: '',
        },
        /**
         * Включает перемещение нижнего подчеркивания к активному табу
         */
        stickyUnderline: {
            type: Boolean,
            default: false,
        },
        /**
         * Определяет тег HTML для элемента
         */
        tag: {
            type: String,
            default: 'div',
        },
        /**
         * Определяет наличие нижнего подчеркивания
         */
        underlined: {
            type: Boolean,
            default: true,
        },
        /**
         * Тема (цветовые решения) для нижнего подчеркивания
         */
        underlineTheme: {
            type: String,
            default: AllColors.SUCCESS,
        },
        /**
         * Id активного таба
         * @model
         */
        modelValue: {
            type: String,
            default: null,
        },
    },
};
</script>

<style lang="scss">
.sbs-tabs {
    position: relative;
    display: flex;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;

    & > * {
        flex-shrink: 0;
    }
}
</style>
